import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true, // Assurez-vous que cette option est activée
});

export default instance;
